import JsSIP from "jssip";
import { UAConfiguration } from "jssip/lib/UA";
import {attachHangupHeaderToEarlyCancel} from "../hangupMarker";

let globalUA: JsSIP.UA | any = null;

const hubRegistry: Set<any> = new Set();

let globalCall: any = null;
let globalConsultationCall: any = null;
let globalIncomingSession: any = null;
let globalPendingIncomingSession: any = null;

export const registerHubConnection = (connection: any) => {
	if (connection) hubRegistry.add(connection);
};

export const unregisterHubConnection = (connection: any) => {
	if (connection) hubRegistry.delete(connection);
};

export const retireHubConnection = async (connection: any) => {
	// TEMP disabled for deploy: nothing calls this until the background-tab fix is restored.
	if (!connection) {
		return;
	}
	try {
		connection.off?.("UpdateStatus");
		connection.off?.("Logout");
		connection.off?.("CallEventInfo");
		connection.off?.("File");
		connection.off?.("DeletePickupCall");
		connection.off?.("SpyStatus");
		connection.off?.("Transcribe");
		connection.off?.("QueueMonitor");
	} catch {
	}
	unregisterHubConnection(connection);
	for (let attempt = 0; attempt < 2 && connection.state && connection.state !== 'Disconnected'; attempt++) {
		try {
			await connection.stop?.();
		} catch {
		}
	}
};

export const stopAllHubConnections = async () => {
	const stops = Array.from(hubRegistry).map(async (conn: any) => {
		try {
			conn?.off?.("UpdateStatus");
			conn?.off?.("Logout");
			conn?.off?.("CallEventInfo");
			conn?.off?.("File");
			conn?.off?.("MonitorUserFirstEvent");
			conn?.off?.("MonitorUserEvent");
			conn?.off?.("StateCampaign");
			conn?.off?.("AllCampaigns");

			conn?.off?.();

			await conn?.stop?.();
		} catch (error) {
			console.error("Error stopping hub connection:", error);
		}
	});
	await Promise.all(stops);
	hubRegistry.clear();
};

export const initGlobalJsSIP = (config: UAConfiguration) => {
	if (!globalUA) {
		globalUA = new JsSIP.UA(config);
		globalUA.start();
	}
};

export const getGlobalJsSIP = () => globalUA;

export const stopGlobalJsSIP = () => {
	if (globalUA) {
		globalUA.stop();
		globalUA.removeAllListeners();
		globalUA = null;
	}
};

export  const changeSession = () => {
	localStorage.setItem('callCentreActiveSession', `${new Date()}`);
};
export const changeActiveTab = () => {
	const now = `${new Date()}`;
	localStorage.setItem('callCentreActiveTab', now);
	sessionStorage.setItem('callCentreActiveTab', now);
};

export const setGlobalCall = (call: any) => {
	globalCall = call;
};

export const setGlobalConsultationCall = (call: any) => {
	globalConsultationCall = call;
};

export const setGlobalIncomingSession = (session: any) => {
	globalIncomingSession = session;
};

const getHangupHeader = (hangupType: 'user' | 'refresh' | 'logout' | 'closed'): string => {
	const hangupTypeMap: Record<'user' | 'refresh' | 'logout' | 'closed', string> = {
		'user': 'by_user_btnclick',
		'refresh': 'by_page_unload',
		'logout': 'by_user_logout',
		'closed': 'by_page_unload'
	};
	return `X-hangup: ${hangupTypeMap[hangupType]}`;
};

export const terminateAllActiveCallsWithUserHeader = (hangupType: 'user' | 'refresh' | 'logout' | 'closed' = 'user') => {
	const hangupHeader = getHangupHeader(hangupType);
	
	if (globalCall !== null) {
		try {
			attachHangupHeaderToEarlyCancel(globalCall, hangupHeader);
			globalCall.terminate({
				extraHeaders: [
					hangupHeader,
				]
			});
		} catch (error) {
			console.error('Error terminating call:', error);
		}
	}
	if (globalConsultationCall !== null) {
		try {
			attachHangupHeaderToEarlyCancel(globalConsultationCall, hangupHeader);
			globalConsultationCall.terminate({
				extraHeaders: [
					hangupHeader,
				]
			});
		} catch (error) {
			console.error('Error terminating consultation call:', error);
		}
	}
	if (globalIncomingSession !== null) {
		try {
			attachHangupHeaderToEarlyCancel(globalIncomingSession, hangupHeader);
			globalIncomingSession.terminate({
				extraHeaders: [
					hangupHeader,
				]
			});
		} catch (error) {
			console.error('Error terminating incoming session:', error);
		}
	}
	if (globalPendingIncomingSession !== null) {
		try {
			attachHangupHeaderToEarlyCancel(globalPendingIncomingSession, hangupHeader);
			globalPendingIncomingSession.terminate({
				extraHeaders: [
					hangupHeader,
				]
			});
		} catch (error) {
			console.error('Error terminating pending incoming session:', error);
		}
	}
};

export const setGlobalPendingIncomingSession = (session: any) => {
	globalPendingIncomingSession = session;
};
